// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--F0g4N","button":"button--Cl3aF"};